import axios from 'axios'
import { useAuthStore } from '../stores'
import { router } from '../router'

console.log("axios init")
const _http = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    responseType: 'json',
    timeout: 60000,
    params: {},
    // validateStatus: function(status) {
    //     if (status >= 401 && status<=403) {
    //         console.error("not authentificated "+ status)
    //     } else {
    //         return status >= 200 && status < 501 // default
    //     }
    // },
})


_http.interceptors.request.use((config)=>{
    const authStore = useAuthStore();
    config = authStore.setAuthHeader(config)
    return config
});

// function endsWith(str, suffix) {
//     return str.indexOf(suffix, str.length - suffix.length) !== -1;
// }
// const respInterseptor = _http.interceptors.response.use(
//     resp=>resp,
//     async (err)=>{

//         const originalConfig = err.config;
//         console.log('origin.retry='+originalConfig._retry + originalConfig)
    
//         if (err.response) {
//             // Access Token was expired
//             if (err.response.status === axios.HttpStatusCode.Unauthorized && !originalConfig._retry && !endsWith(originalConfig.url,'/token/refresh')) {
//                 originalConfig._retry = true;
//                 console.log('origin.retry now='+originalConfig._retry)
        
//                 try {
//                     const authStore = useAuthStore();
//                     axios.interceptors.response.eject(respInterseptor)
//                     let refresh_ok = await authStore.refresh() 
//                     axios.interceptors.response.use(respInterseptor)
//                     console.log('refresh_ok='+refresh_ok)
//                     if (refresh_ok)
//                         return _http(originalConfig);
//                 } catch (_error) {
//                     if (_error.response && _error.response.data) {
//                         throw(_error.response.data);
//                     }
//                     throw(_error);
//                 }
//             }
//             if (err.response.status === axios.HttpStatusCode.Forbidden) {
//                 notify = useNotification()
//                 notify({
//                     title: "Нет прав доступа",
//                     text: `${err}`,
//                     type: "error",
//                 });  
//                 router.push('/');
//                 throw err;
//             } else 
//                 throw err;
//         }
//     }        
// );



/**
 * Wrap the interceptor in a function, so that i can be re-instantiated
 */
function createAxiosResponseInterceptor() {
    const interceptor = _http.interceptors.response.use(
        (response) => response,
        (error) => {
            // Reject promise if usual error
            if (error.code == 'ERR_NETWORK' || error.response.status !== 401) {
                return Promise.reject(error);
            }

            /*
             * When response code is 401, try to refresh the token.
             * Eject the interceptor so it doesn't loop in case
             * token refresh causes the 401 response.
             *
             * Must be re-attached later on or the token refresh will only happen once
             */
            _http.interceptors.response.eject(interceptor);
            const authStore = useAuthStore();
            console.log("refreshing auth token")
            return _http
                // .post("/APIURL/auth/v1/token/refresh", {refresh_token: authStore.token.refresh_token},
                .post("/auth/v1/token/refresh", {refresh_token: authStore.token.refresh_token},
                )
                .then((response) => {
                    console.log("saving new auth token")
                    authStore.saveTokens(response);
                    console.log(`new auth token ${authStore.token.access_token}`)
                    error.response.config.headers["Authorization"] =
                        "Bearer " + response.data.access_token;
                    // Retry the initial call, but with the updated token in the headers. 
                    // Resolves the promise if successful
                    return axios(error.response.config);
                })
                .catch((error2) => {
                    // Retry failed, clean up and reject the promise
                    console.log("error refreshing auth token")
                    authStore.clearTokens()
                    console.log("redirecting to /account/login")
                    router.push("/account/login");
                    return Promise.reject(error2);
                })
                .finally(createAxiosResponseInterceptor); // Re-attach the interceptor by running the method
        }
    );
}

createAxiosResponseInterceptor(); // Execute the method once during start

export const http = _http;